import { render, staticRenderFns } from "./ProgressScore.vue?vue&type=template&id=ea3b57d4&scoped=true"
import script from "./ProgressScore.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressScore.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProgressScore.vue?vue&type=style&index=0&id=ea3b57d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3b57d4",
  null
  
)

export default component.exports